import React, { useState } from "react";
import Chart from "react-apexcharts";



export default function Putawaytimechart() {
    const [Putawaylead, SetPutawaylead] = useState({
        options: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          colors: ["#1F78B4"],
    
          xaxis: {
            categories: [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec",
            ],
          },
          yaxis: {
            forceNiceScale: false,
            max: 100,
            labels: {
              formatter: (value) => value.toFixed(0) + "%",
            },
          },
          stroke: {
            curve: "smooth",
          },
          markers: {
            size: 4,
          },
          states: {
            normal: {
              filter: {
                type: "none",
                value: 0,
              },
            },
            hover: {
              filter: {
                type: "lighten",
                value: 0.15,
              },
            },
            active: {
              allowMultipleDataPointsSelection: false,
              filter: {
                type: "darken",
                value: 0.35,
              },
            },
          },
        },
    
        series: [
          {
            name: "Items",
            data: [83, 80, 92, 87, 95, 90, 97, 87, 84, 78, 87, 96],
          },
        ],
      });
  return (
    <div>
     <div className="mt-8 sm:w-full md:w-full">
    <div class=" shadow-slate-400 shadow-md bg-white rounded-2xl flex-1">
      <div className="flex flex-wrap mr-4 mt-2 pt-2">
        <h3 className="text-lg font-bold mx-3"> Putaway Cycle Time</h3>
        <div className="float-right ml-auto mr-4 mt-1">
          
          <div className="float-right">
            <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
              {" "}
              M
            </button>
          </div>
          <div className="float-right">
            <button className="rounded-full text-blue-900 w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
              {" "}
              Y
            </button>
          </div>
          <div className="relative text-gray-600 mr-3  border-1 rounded-3xl ml-10 float-right focus-within:text-gray-400">
            <span className="absolute text-slate-400 inset-y-0 left-0 flex items-center pl-2">
              <button
                type="submit"
                className="p-1 focus:outline-none focus:shadow-outline"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M4 6h16M4 12h8m-8 6h16"
                  />
                </svg>
              </button>
            </span>
            <input
              type="search"
              className="py-2 text-sm outline-slate-100 outline focus:outline-slate-200 rounded-full pl-10 focus:outline-1 focus:bg-white focus:text-gray-900"
              placeholder="Filter"
              autocomplete="off"
            />
          </div>
          
        </div>
      </div>
      <Chart className="lg:px-10 m-auto sm:px-0 sm:w-full"
        options={Putawaylead.options}
        series={Putawaylead.series}
        type="line"
        height="400"
        width="100%"
      />
    </div>
  </div>
    
    </div>
  )
}
